import ManuscriptsSubmitted from "../manuscriptsSubmitted/ManuscriptsSubmitted";
import InterviewManuscript from "../interviewManuscript/InterviewManuscript";
import MyManuscript from '../myManuscript/MyManuscript';
import AllArticles from '../allArticles/AllArticles';
import RecycleBin from '../ recycleBin/RecycleBin'
import HtmlDiffRouter from "../../editor/htmldiff/htmldiff";
import OtherMediaManuscript from "../otherMediaManuscript/otherMediaManuscript"
import Detail from "../otherMediaManuscript/component/Details";
import AppointmentStory from "../appointmentStory/appointmentStory";
export  const  materialCenterRouter =[
    {
        path:'/view/materialCenter/manuscriptsSubmitted', //素材中心投稿稿件
        component:ManuscriptsSubmitted
    },
    {
        path:'/view/materialCenter/interviewManuscript', //素材中心采访稿件
        component:InterviewManuscript
    },
    {
        path:'/view/manuscriptsMedia/appointmentStory', //素材中心约稿稿件
        component:AppointmentStory
    },
    {
        path:'/view/myManuscript/myManuscript', //素材中心我的稿件
        component:MyManuscript
    },
    {
        path:'/view/allArticles/allArticles', //素材中心全部稿件
        component:AllArticles
    },
    {
        path:'/view/recycleBin/recycleBin', //素材中心回收站
        component: RecycleBin
    },
    {
        path:'/view/otherMediaManuscript/otherMediaManuscript', //素材中心其他媒体稿件
        component: OtherMediaManuscript
    },
    {
        path:'/view/htmldiff/htmldiff/:componentName/:dataType/:id', //版本对比
        component: HtmlDiffRouter,
        frame: "no-frame"
    },
    {
        path: "/view/otherMediaManuscript/details",
        frame:'no-frame',
        component: Detail
    },
];